<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">ALTERKNIT<br/>REBELLION</h1>
<h2 class="description">Radical Patterns for Creative Knitters</h2>
<p class="author">Anna Bauer</p>
<p class="logo"><img alt="" src="images/logo.gif"/></p>
<p class="publisher"><a href="http://www.davidandcharles.com" target="_blank">www.davidandcharles.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?2a4b1e8e